import { useEffect } from "react"
import { useLocation } from "react-router-dom"

export const APP_TITLE = "AMOK . EARTH"
export const ADMIN_TITLE = "AMOK . EARTH Admin"

const TITLE_RULES = [
  { pattern: /^\/admin\/requests/, title: "Requests", admin: true },
  { pattern: /^\/admin\/dashboard/, title: "Dashboard", admin: true },
  { pattern: /^\/admin\/cities\/create/, title: "Add City", admin: true },
  { pattern: /^\/admin\/cities\/[^/]+\/edit/, title: "Edit City", admin: true },
  {
    pattern: /^\/admin\/cities\/[^/]+\/members\/[^/]+\/edit/,
    title: "Edit Profile",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/members\/[^/]+/,
    title: "Profile Overview",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/members/,
    title: "Members",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/projects/,
    title: "Projects",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/reviews/,
    title: "Reviews",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/calls/,
    title: "Calls for Artists",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/shadow-working-events/,
    title: "Shadow Working Events",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/rewards/,
    title: "Treasure",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/photography/,
    title: "Photography",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/flags/,
    title: "Flags & Reports",
    admin: true,
  },
  {
    pattern: /^\/admin\/cities\/[^/]+\/transfers/,
    title: "City Transfer Requests",
    admin: true,
  },
  { pattern: /^\/admin\/cities\/[^/]+/, title: "City Detail", admin: true },
  { pattern: /^\/admin\/cities/, title: "Cities", admin: true },
  { pattern: /^\/admin\/projects\/create/, title: "Create Project", admin: true },
  {
    pattern: /^\/admin\/projects\/[^/]+\/edit/,
    title: "Edit Project",
    admin: true,
  },
  { pattern: /^\/admin\/projects\/[^/]+\/overview/, title: "Overview", admin: true },
  {
    pattern: /^\/admin\/projects\/[^/]+\/tasks\/[^/]+\/detail\//,
    title: "Task Detail",
    admin: true,
  },
  { pattern: /^\/admin\/projects\/[^/]+\/tasks\/[^/]+/, title: "My Tasks", admin: true },
  { pattern: /^\/admin\/projects\/[^/]+\/my-tasks/, title: "My Tasks", admin: true },
  { pattern: /^\/admin\/projects\/[^/]+\/tasks/, title: "All Tasks", admin: true },
  {
    pattern: /^\/admin\/projects\/[^/]+\/sessions\/[^/]+/,
    title: "Session Detail",
    admin: true,
  },
  { pattern: /^\/admin\/projects\/[^/]+\/sessions/, title: "Sessions", admin: true },
  { pattern: /^\/admin\/projects\/[^/]+\/calendar/, title: "Calendar", admin: true },
  {
    pattern: /^\/admin\/projects\/[^/]+\/collaborators/,
    title: "Collaborators",
    admin: true,
  },
  { pattern: /^\/admin\/projects\/[^/]+\/messages/, title: "Messages", admin: true },
  { pattern: /^\/admin\/projects/, title: "Projects", admin: true },
  { pattern: /^\/admin\/sessions\/[^/]+/, title: "Session Detail", admin: true },
  { pattern: /^\/admin\/sessions/, title: "Sessions", admin: true },
  { pattern: /^\/admin\/members\/[^/]+\/edit/, title: "Edit Profile", admin: true },
  { pattern: /^\/admin\/members\/[^/]+/, title: "Profile Overview", admin: true },
  { pattern: /^\/admin\/members/, title: "Members", admin: true },
  { pattern: /^\/admin\/rewards/, title: "Treasure & XP", admin: true },
  { pattern: /^\/admin\/inbox\/[^/]+/, title: "Call Detail", admin: true },
  { pattern: /^\/admin\/inbox/, title: "Inbox & Calls", admin: true },
  { pattern: /^\/admin\/photography/, title: "Photography", admin: true },
  { pattern: /^\/admin\/arts-genome\/spellbook\/create/, title: "Create Spellbook", admin: true },
  { pattern: /^\/admin\/arts-genome\/class\/create/, title: "Create Class Type", admin: true },
  { pattern: /^\/admin\/arts-genome\/keyword\/create/, title: "Create Keyword Mapping", admin: true },
  {
    pattern: /^\/admin\/arts-genome\/spellbook\/[^/]+\/edit/,
    title: "Edit Spellbook",
    admin: true,
  },
  {
    pattern: /^\/admin\/arts-genome\/class\/[^/]+\/edit/,
    title: "Edit Class Type",
    admin: true,
  },
  {
    pattern: /^\/admin\/arts-genome\/keyword\/[^/]+\/edit/,
    title: "Edit Keyword Mapping",
    admin: true,
  },
  { pattern: /^\/admin\/arts-genome/, title: "Arts Genome", admin: true },
  { pattern: /^\/admin\/blogs/, title: "Blogs Management", admin: true },
  { pattern: /^\/admin\/flags/, title: "Flags & Reports", admin: true },
  { pattern: /^\/admin\/notifications/, title: "Notifications", admin: true },
  { pattern: /^\/admin\/activity-log/, title: "Admin Logs", admin: true },
  { pattern: /^\/admin\/mailgun/, title: "MailGun", admin: true },
  { pattern: /^\/admin\/staff\/[^/]+/, title: "Staff Profile", admin: true },
  { pattern: /^\/admin\/staff/, title: "Staff Management", admin: true },
  { pattern: /^\/admin\/roles\/create/, title: "Create Role", admin: true },
  { pattern: /^\/admin\/roles\/[^/]+/, title: "Role Detail", admin: true },
  { pattern: /^\/admin\/roles/, title: "Roles & Permissions", admin: true },
  { pattern: /^\/admin\/settings\/notifications/, title: "Settings — Notifications", admin: true },
  { pattern: /^\/admin\/settings/, title: "Settings", admin: true },
  { pattern: /^\/admin/, title: "Admin", admin: true },

  { pattern: /^\/dashboard/, title: "Dashboard" },
  { pattern: /^\/projects\/create/, title: "Create Project" },
  { pattern: /^\/projects\/[^/]+\/edit/, title: "Edit Project" },
  { pattern: /^\/projects\/[^/]+\/overview/, title: "Overview" },
  { pattern: /^\/projects\/[^/]+\/tasks\/[^/]+\/detail\//, title: "Task Detail" },
  { pattern: /^\/projects\/[^/]+\/tasks\/[^/]+/, title: "My Tasks" },
  { pattern: /^\/projects\/[^/]+\/my-tasks/, title: "My Tasks" },
  { pattern: /^\/projects\/[^/]+\/tasks/, title: "All Tasks" },
  { pattern: /^\/projects\/[^/]+\/sessions\/[^/]+/, title: "Session Detail" },
  { pattern: /^\/projects\/[^/]+\/sessions/, title: "Sessions" },
  { pattern: /^\/projects\/[^/]+\/calendar/, title: "Calendar" },
  { pattern: /^\/projects\/[^/]+\/collaborators/, title: "Collaborators" },
  { pattern: /^\/projects\/[^/]+\/messages/, title: "Messages" },
  { pattern: /^\/projects/, title: "Projects" },

  { pattern: /^\/collaborators/, title: "Collaborators" },
  { pattern: /^\/activity-log/, title: "Activity Log" },
  { pattern: /^\/flags\/[^/]+/, title: "Flag Details" },
  { pattern: /^\/flags/, title: "My Flags" },
  { pattern: /^\/invites/, title: "Invites" },
  { pattern: /^\/rewards\/activity/, title: "XP Activity" },
  { pattern: /^\/rewards/, title: "Treasure & XP" },
  { pattern: /^\/notifications/, title: "Notifications" },

  { pattern: /^\/calls-for-artist\/[^/]+/, title: "Call Detail" },
  { pattern: /^\/calls-for-artist/, title: "Inboxes & Calls for Artists" },

  { pattern: /^\/city-hub\/[^/]+\/calls-for-artists/, title: "Inboxes & Calls for Artists | City Hub" },
  { pattern: /^\/city-hub\/calls-for-artists/, title: "Inboxes & Calls for Artists | City Hub" },
  { pattern: /^\/city-hub\/[^/]+\/city-inbox/, title: "City Inbox | City Hub" },
  { pattern: /^\/city-hub\/city-inbox/, title: "City Inbox | City Hub" },
  { pattern: /^\/city-hub\/[^/]+\/shadow-working-events/, title: "Shadow Working Events | City Hub" },
  { pattern: /^\/city-hub\/shadow-working-events/, title: "Shadow Working Events | City Hub" },
  { pattern: /^\/city-hub\/[^/]+\/local-reviews/, title: "Local Reviews | City Hub" },
  { pattern: /^\/city-hub\/local-reviews/, title: "Local Reviews | City Hub" },
  { pattern: /^\/city-hub\/[^/]+\/photography/, title: "Photography | City Hub" },
  { pattern: /^\/city-hub\/photography/, title: "Photography | City Hub" },
  { pattern: /^\/city-hub\/[^/]+\/creators/, title: "Creators | City Hub" },
  { pattern: /^\/city-hub\/creators/, title: "Creators | City Hub" },
  { pattern: /^\/city-hub\/calls/, title: "Call Detail | City Hub" },
  { pattern: /^\/city-hub\/inbox/, title: "Inbox Detail | City Hub" },
  { pattern: /^\/city-hub\/events/, title: "Event Detail | City Hub" },
  { pattern: /^\/city-hub\/blogs/, title: "Blog Detail | City Hub" },
  { pattern: /^\/city-hub/, title: "City Hub" },

  { pattern: /^\/public\/profile/, title: "Public Profile" },
  { pattern: /^\/profile\/edit/, title: "Edit Profile" },
  { pattern: /^\/profile/, title: "My Profile" },

  { pattern: /^\/login/, title: "Login" },
  { pattern: /^\/logout/, title: "Logout" },
  { pattern: /^\/verify-otp/, title: "Email Verification" },
  { pattern: /^\/forgot-password/, title: "Forgot Password" },
  { pattern: /^\/reset-password/, title: "Reset Password" },
  { pattern: /^\/request-invite/, title: "Request An Invite" },
  { pattern: /^\/create-account/, title: "Create Account" },
  { pattern: /^\/register/, title: "Register" },
  { pattern: /^\/onboarding/, title: "Onboarding" },
]

export const getDocumentTitle = (pathname = "") => {
  const rule = TITLE_RULES.find(({ pattern }) => pattern.test(pathname))
  if (!rule) return APP_TITLE
  const suffix = rule.admin ? ADMIN_TITLE : APP_TITLE
  return `${rule.title} | ${suffix}`
}

/**
 * Sets the browser tab title from the current route, e.g.
 * "Dashboard | AMOK . EARTH" / "Overview | AMOK . EARTH".
 */
const DocumentTitle = ({ children }) => {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = getDocumentTitle(pathname)
  }, [pathname])

  return children || null
}

export default DocumentTitle
